import { FluentIcon } from "@fluentui/react-icons";

import { IAppMenuFlyoutProps } from "./AppHeaderMenu/Flyouts/AppMenuFlyout.types";
import { TeamAppModel } from "Apps/TeamAppModel";

export const FeedbackCategory = {
    ReportProblem: "Report a problem",
    GiveCompliment: "Give a compliment",
    SuggestFeature: "Suggest a new feature"
} as const;

export type FeedbackCategoryValue = (typeof FeedbackCategory)[keyof typeof FeedbackCategory];

export interface FeedbackCategoryOptionProps {
    category: FeedbackCategoryValue;
    icon: FluentIcon;
    label: string;
}

export interface UserFeedbackSubmitData {
    requestId: string;
    comment: string;
}

export interface IUserFeedbackFlyoutProps extends IAppMenuFlyoutProps {
    onSubmit?: () => void;
    /** Called on successful submission with the request ID and comment text. */
    onSubmitData?: (data: UserFeedbackSubmitData) => void;
    selectedApp?: TeamAppModel;
}
